export const term_policy = `
<h1>이용약관</h1>

<ul>
    <li>1조 목적</li>
    <li>2조 약관의 효력과 변경</li>
    <li>3조 약관 외 준칙</li>
    <li>4조 이용계약의 체결</li>
    <li>5조 이용계약의 해지</li>
    <li>6조 서비스</li>
    <li>7조 회사의 의무</li>
    <li>8조 개인정보의 보호</li>
    <li>9조 회원의 의무</li>
    <li>10조 저작권</li>
    <li>11조 기타</li>
</ul>

<h2 style="margin-top: 15px">제 1 조 목적</h2>
<p>이 약관은 퍼스널뉴스서비스 서비스의 이용조건 및 절차, 권리와 의무, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>

<h2 style="margin-top: 15px">제 2 조 약관의 효력과 변경</h2>
<ol>
    <li>서비스는 본 약관에 규정된 조항을 회원이 수락하는 것을 조건으로 제공되며 회원이 회원가입시 "동의" 단추를 누름과 동시에 이 약관에 동의하는 것으로 간주됩니다.</li>
    <li>이 약관은 온라인을 통해 공시함으로써 효력을 발생합니다.</li>
    <li>회사는 불가피한 변경의 사유가 있을 때 약관을 임의로 변경할 권한을 가지며 변경된 약관은 온라인을 통해 공지됨으로써 효력이 발생됩니다.</li>
    <li>회원은 변경된 약관에 동의하지 않을 경우 탈퇴를 요청할 수 있으며 변경된 약관의 효력발생일 이후에도 계속적으로 서비스를 이용하는 경우에는 회원이 약관의 변경 사항에 동의한 것으로 봅니다.</li>
</ol>

<h2 style="margin-top: 15px">제 3 조 약관 외 준칙</h2>
<ul>
    <li>이 약관에 명시되지 않은 사항에 대해서는 국내 관련 법령 규정에 따릅니다.</li>
</ul>

<h2 style="margin-top: 15px">제 4 조 이용계약의 체결</h2>
<ol>
    <li>이용계약은 회원의 회원가입신청을 회사가 승낙 함으로써 성립합니다.</li>
    <li>회사는 신청서의 내용이 허위이거나 규정한 제반 사항을 위반하여 신청한 경우 가입 신청을 거절할 수 있습니다.</li>
</ol>


<h2 style="margin-top: 15px">제 5 조 이용계약의 해지</h2>
<ol>
    <li>회원은 회사에 언제든 이용계약의 해지를 요청할 수 있습니다.</li>
    <li>회사는 회원의 해지 요청이 접수된 즉시 회원을 탈퇴 처리 하고 관련 법령 및 개인정보처리방침에 명시된 경우를 제외한 개인정보를 삭제합니다.</li>
    <li>회사는 회원이 제9조 회원의 의무에 위배되는 행위를 한 경우 사전통지 없이 이용계약의 해지, 제한, 정지할 수 있습니다.</li>
</ol>

<h2 style="margin-top: 15px">제 6 조 서비스</h2>
<ol>
    <li>
        <p>회사는 다음과 같은 서비스를 제공합니다.</p>
        <ul>
            <li>뉴스 서비스</li>
            <li>동영상 서비스</li>
            <li>게시판 서비스</li>
            <li>설문조사 서비스</li>
            <li>DB 서비스</li>
        </ul>
    </li>
    <li>회사는 필요한 경우 서비스 내용을 추가, 변경, 삭제할 수 있습니다.</li>
</ol>


<h2 style="margin-top: 15px">제 7 조 회사의 의무</h2>
<ol>
    <li>회사는 지속적, 안정적으로 서비스가 제공되도록 최선의 노력을 다하여야 합니다.</li>
    <li>회사는 24시간 365일 서비스 제공을 원칙으로 합니다. 다만 정기점검, 천재지변, 비상사태 등 부득이한 사유가 발생한 경우 서비스를 일시 중단할 수 있습니다.</li>
</ol>

<h2 style="margin-top: 15px">제 8 조 개인정보의 보호</h2>
<ol>
    <li>회사는 서비스와 관련하여 수집된 회원의 개인정보를 본인의 사전 승낙없이 제3자에게 공개 또는 배포할 수 없습니다. 다만 관련 법령에 의한 관계기관의 요구가 있을 경우 그러하지 아니합니다.</li>
    <li>회사는 개인정보 보호책임자를 비롯한 개인정보에 관한 기타 사항을 별도로 정한 “개인정보처리방침”에 기재하여 공지합니다.</li>
</ol>

<h2 style="margin-top: 15px">제 9 조 회원의 의무</h2>
<ol>
    <li>ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.</li>
    <li>회원은 자신의 ID를 제3자에게 양도, 대여할 수 없습니다.</li>
    <li>회원은 자신의 ID가 부정하게 사용된 경우 반드시 회사에 통보하여야 합니다.</li>
    <li>회원은 회원가입시 입력항목에 허위, 오기, 누락이 없도록 하여야 합니다.</li>
    <li>회원은 제3자의 권리나 저작권 등을 침해하는 행위를 할 수 없습니다.</li>
    <li>회원은 이 약관 및 관계법령에서 규정한 사항을 준수하여야 하며 기타 회사의 업무에 방해되는 행위를 하여서는 안됩니다.</li>
    <li>회원은 회사의 사전 승낙없이 서비스를 이용하여 어떠한 영리행위도 할 수 없습니다.</li>
</ol>

<h2 style="margin-top: 15px">제 10 조 저작권</h2>
<ol>
    <li>회사의 모든 서비스에 대한 저작권은 회사 및 회사에 콘텐츠를 제공하는 제공처, 광고주에 있습니다. 이 모든 저작물은 저작권법 및 관계 법령에 의해 보호받으며 회사, 콘텐츠 제공처, 광고주의 사전 승낙 없이 복제, 출판, 전송, 배포, 방송 기타 방법에 의하여 이용하거나 제3자에게 이용하게 할 수 없으며, 저작물에 대한 저작권 침해는 관계 법령의 적용을 받습니다.</li>
    <li>회사는 회원이 서비스내의 기사의견, 게시판 등에 올린 내용에 대해 책임이 없습니다.</li>
    <li>회사는 저작권에 관한 기타 사항을 별도로 정한 “저작권정책”에 기재하여 공지합니다.</li>
</ol>
<h2 style="margin-top: 15px">제 11 조 기타</h2>
<ul>
    <li>본 약관은 공정거래위원회 표준 약관에 근거하여 작성되었습니다.</li>
</ul>
`
